// removed by extract-text-webpack-plugin
module.exports = {"container":"mobileNavSearchBar__container__88ee950c","overlay":"mobileNavSearchBar__overlay__88ee950c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileNav/MobileNavSearchBar/mobileNavSearchBar.scss
// module id = ./src/components/MobileNav/MobileNavSearchBar/mobileNavSearchBar.scss
// module chunks = 4